import { useContext, useSyncExternalStore } from 'react';
import { FullscreenStoreContext, type FullscreenState } from '../fullscreen-context';

// Дефолты на случай рендера вне FullscreenProvider — так было и в исходном
// коде (осознанный выбор без throw, сохраняем поведение при переносе на стор)
const DEFAULT_STATE: FullscreenState = {
  isFullscreen: false,
  needFullscreenButton: false,
  headerEnabled: true,
  handler: null,
};

const NOOP_SUBSCRIBE = () => () => {};

function useFullscreenSelector<R>(selector: (state: FullscreenState) => R): R {
  const store = useContext(FullscreenStoreContext);
  const getSnapshot = () => selector(store ? store.getSnapshot() : DEFAULT_STATE);

  return useSyncExternalStore(store ? store.subscribe : NOOP_SUBSCRIBE, getSnapshot, getSnapshot);
}

// Готовые именованные селекторы на каждое поле fullscreen-стейта — точечная подписка
// вместо useFullscreen(), ре-рендерящего всех потребителей на изменение любого поля
export const useIsFullscreen = () => useFullscreenSelector((s) => s.isFullscreen);
export const useNeedFullscreenButton = () => useFullscreenSelector((s) => s.needFullscreenButton);
export const useHeaderEnabled = () => useFullscreenSelector((s) => s.headerEnabled);
export const useFullscreenHandler = () => useFullscreenSelector((s) => s.handler);
